import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';

function AdminPageHeader({
  eyebrow,
  title,
  description,
  meta,
  action,
}) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
    >
      <Box sx={{ minWidth: 0 }}>
        {eyebrow ? (
          <Chip
            label={eyebrow}
            size="small"
            variant="outlined"
            sx={{ mb: 1.5, bgcolor: 'background.paper' }}
          />
        ) : null}
        <Typography variant="h4">{title}</Typography>
        {description ? (
          <Typography color="text.secondary" sx={{ mt: 1, maxWidth: 780 }}>
            {description}
          </Typography>
        ) : null}
      </Box>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.25}
        alignItems={{ xs: 'stretch', md: 'center' }}
        sx={{ width: { xs: '100%', md: 'auto' } }}
      >
        {meta}
        {action}
      </Stack>
    </Stack>
  );
}

export default AdminPageHeader;
